/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLogo } from '../hooks/useLogo';
type LogoLinkProps = { children: React.ReactNode };

const LogoLink = ({ children }: LogoLinkProps) => {
	//   const renderTokens = (): string => {
	//     return `... ${width} ...`;
	//   };

	//   const renderStyles = () => {
	//     return {
	//       color: color,
	//     };
	//   };
	const { blockClass } = useLogo();

	return (
		<a
			className={`logoLink logoLink--${blockClass} vtex-store-components-3-x-logoLink ${blockClass ? 'vtex-store-components-3-x-logoLink--' + blockClass : ''} `}
		>
			{children}
		</a>
	);
};

export default LogoLink;
